const SUPPLIERS_QUERY = process.env.SUPPLIERS_QUERY || '$/1-FIA/Drafts/Suppliers Guide - Test';
const CATEGORIES_QUERY = process.env.CATEGORIES_QUERY || '$/1-FIA/Drafts/Supplier Categories';
const API_BASE = process.env.API_BASE || '/api';

function getRequestVerificationToken() {
  const tokenInput = document.getElementById('__RequestVerificationToken');

  if (!tokenInput?.value) {
    throw new Error('Missing __RequestVerificationToken hidden input on the page. Make sure this React app is embedded on the iMIS page that provides that token.');
  }

  return tokenInput.value;
}

function buildApiUrl(path) {
  const base = API_BASE.endsWith('/') ? API_BASE.slice(0, -1) : API_BASE;
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;

  return new URL(`${base}${normalizedPath}`, window.location.origin);
}

async function fetchIqa(queryName, { token, limit, offset } = {}) {
  const requestToken = token || getRequestVerificationToken();
  const url = buildApiUrl('/IQA');

  url.searchParams.set('queryname', queryName);

  if (limit !== undefined) {
    url.searchParams.set('limit', String(limit));
  }

  if (offset !== undefined) {
    url.searchParams.set('offset', String(offset));
  }

  const response = await fetch(url.toString(), {
    method: 'GET',
    headers: {
      RequestVerificationToken: requestToken,
      Accept: 'application/json'
    },
    credentials: 'same-origin'
  });

  if (!response.ok) {
    const message = await response.text().catch(() => '');
    throw new Error(`IQA request failed: ${response.status} ${response.statusText}${message ? ` - ${message}` : ''}`);
  }

  return response.json();
}

export async function getCategories(token) {
  return fetchIqa(CATEGORIES_QUERY, { token });
}

export async function getSuppliersPage(token, offset = 0) {
  return fetchIqa(SUPPLIERS_QUERY, {
    token,
    limit: 500,
    offset
  });
}

export async function getAllSuppliers(token) {
  const allSuppliers = [];
  let offset = 0;

  while (true) {
    const data = await getSuppliersPage(token, offset);
    allSuppliers.push(...parsePropertyItems(data));

    if (!data?.HasNext) {
      break;
    }

    offset = data.NextOffset;
  }

  return allSuppliers;
}

export function getPageToken() {
  return getRequestVerificationToken();
}

export function getSelectedPartyId() {
  const clientContext = document.querySelector('#__ClientContext');

  if (!clientContext?.value) {
    return null;
  }

  try {
    return JSON.parse(clientContext.value)?.selectedPartyId ?? null;
  } catch {
    return null;
  }
}

export function parsePropertyItems(data) {
  const items = data?.Items?.$values ?? [];

  return items.map((item) => {
    const properties = item?.Properties?.$values ?? [];

    return properties.reduce((result, property) => {
      if (property?.Name && property.Name !== 'ResultRow') {
        result[property.Name] = property.Value ?? '';
      }

      return result;
    }, {});
  });
}
